/**
 * Fone Dynamic Fone fix
 */
export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  'use strict';

  let initialized = false;
  
  return async () => {
    if (initialized) {
      // do not runs more then once
      return;
    }

    initialized = true;

    if (typeof window._ctq !== 'undefined' && Array.isArray(window._ctq)) {
      window._ctq.forEach(entry => {
        if (Array.isArray(entry) && entry[0] === 'onNumberAvailable' && typeof entry[1] === 'function') {
          const orgCallback = entry[1];

          entry[1] = (...args) => {
            // temporariliy assign $ with local context jQuery
            var tmp$ = window.$;
            window.$ = $;

            // call the original function
            orgCallback.apply(this, args);

            // revert global $ variable
            window.$ = tmp$;
          };
        }
      });
    }
  };

})(jQuery, window);